import { Component, ViewChild, AfterViewInit, ElementRef, OnInit, Renderer2, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
// import { Meetup, MiteventsService, testimonial } from '../mitevents.service';
import { Constants } from '../../common/constants';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { trigger, state, style, animate, transition, query, group } from '@angular/animations';
import { MatAccordion } from '@angular/material/expansion';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Meetup, MiteventsService, testimonial } from '../../mitevents.service';
import { ThankYouPopupComponent } from '../../common/thank-you-popup/thank-you-popup.component';
import { PaymentService } from '../services/payment.service';
import { SeoService } from 'src/app/common/seo.service';
declare var $: any;
declare var WOW: any;
declare var Razorpay: any;

export interface EventTestimonial {
  id: number;
  name: string;
  designation: string;
  comment: string;
  meetUpId: number;
  meetUpName: string;

}



interface GalleryImage {
  id: number;
  imageUrl: string;
}
@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.css'],
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(1000, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate(1000, style({ opacity: 0 }))
      ])
    ])
  ]
})
export class EventDetailsComponent implements OnInit, AfterViewInit {
  eventId !: number;
  event!: Meetup;
  showEvents: boolean = false;
  form!: FormGroup<any>;
  isSubmitting: boolean = false;
  thankYouVisible: boolean = true;
  dialogRef!: MatDialogRef<ThankYouPopupComponent>;
  selectedFile!: File;
  today = new Date();
  pageUrl: string = "";
  currentUrl !: string;
  isPastEvent!: boolean;
  galleryImages: GalleryImage[] = [];
  testimonials: any[] = [];
  isBrowser: boolean = false;
  eventSpeakers:boolean=false;
  baseUrl = Constants.baseUrl;
  loading = false;
  separateDialCode = true;
  isTestimonialsExists: boolean = false;

  @ViewChild('bgvid') videoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild(MatAccordion) accordion !: MatAccordion;

  swiperBreakpoints = {
    320: { slidesPerView: 1 },
    768: { slidesPerView: 2 },

  };


  testimonialChunks: testimonial[][] = [];

  constructor(private route: ActivatedRoute, private el: ElementRef, private renderer: Renderer2, private router: Router, private viewportScroller: ViewportScroller,
    private eventService: MiteventsService, private fb: FormBuilder, private http: HttpClient, private dialog: MatDialog, private titleService: Title,private seoService:SeoService,
    private metaService: Meta, @Inject(PLATFORM_ID) private platformId: any,private paymentService:PaymentService

  ) { this.isBrowser=isPlatformBrowser(this.platformId);}
  ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.route.params.subscribe(params => {
      this.eventId = params['id'];
      this.fetchEventDetails();
      this.loadRazorpayScript();



    });
    if (this.isBrowser) {
      AOS.init({ disable: 'mobile', duration: 2000, delay: 500, }); AOS.refresh;
      new WOW().init();
      const inputElemnt = document.getElementById('#phone');
    }


    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();

    this.form = this.fb.group({

      Name: ['', [Validators.required, Validators.maxLength(50),this.customNameValidator(),Validators.pattern(/^[a-zA-Z]{3,}([ ]?[a-zA-Z]+)*$/) ]],
      College: ['', [Validators.required, this.  customCollegeNameValidator(), Validators.maxLength(50),Validators.minLength(3)]],
      Qualification: ['', [Validators.required, Validators.pattern(/^[a-zA-Z ]*$/),Validators.maxLength(50),Validators.minLength(3)]],
      Email: ['', [Validators.required, this.customEmailValidator()]],
      Phone: ['', [Validators.required, this.customPhoneValidator()]],
      Designation: [''],
      meetUpId: this.eventId,
      position: ['']
    });


   
    this.loadTestimonials(this.eventId);
  }


  private setTitleAndMetaTags(): void {
    // Set page title
    this.titleService.setTitle('');

    // Set meta tags
    this.metaService.addTags([
      { name: 'description', content: 'We understand that speed, quality, and productivity are crucial to your success.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Event Details' },
      { property: 'og:url', content: `https://mitresource.com/event-details/${this.eventId}/` },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/testingimages/fast-track-img.webp' },
      { property: 'og:description', content: 'We understand that speed, quality, and productivity are crucial to your success.' },
    ]);
  }

  ngAfterViewInit(): void {
    if (this.isBrowser) {

    const swiperElements = this.empSwiperContainer.nativeElement;
    const shadowRoots = swiperElements.shadowRoot;
    if (shadowRoots) {
      const page = shadowRoots.querySelector('.swiper-pagination')
      if (page) {
        this.renderer.setStyle(page, 'position', 'unset');
      }
      else {
        // console.error('Pagination element not found in shadow root');
      }
    } else {

      // console.error('Shadow root not found');
    }
    $('.lightbox').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true
      }
    });

    this.ensureMuted();

  }
  }
  getGalleryImageUrl(imagePath: string): string {
    if (imagePath) {
      return Constants.baseImageUrl + imagePath;
    } else {
      return '../../../assets/images/InternshipPage/business-conference-banner-template-design-for-webinar-marketing-online-class-program-etc-free-vector.jpg';
    }
  }
  ensureMuted(): void {
    if (this.videoElement && this.videoElement.nativeElement) {
      this.videoElement.nativeElement.muted = true;
    }
  }

  toggleVideo(): void {
    const video: HTMLVideoElement = this.videoElement.nativeElement;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }

  scrollToSection(sectionId: string): void {
    this.viewportScroller.scrollToAnchor(sectionId);
  }

  fetchEventDetails() {
    if(this.eventId){
    this.eventService.getMeetupById(this.eventId).subscribe((event: any) => {
      this.event = event;
      this.showEvents = true;
      this.galleryImages = event.meetUpGalleryImages.map((img: any) => ({
        id: img.id,
        imageUrl: img.imageUrl
      }));
     if(this.event.selectedSpeakers.length>0){this.eventSpeakers=true;}
      this.splitEvent();
    });
  }
  }
  navigateToEventForm() {
    let navigationExtras: NavigationExtras = {
      fragment: 'eventForm'
    };
    this.router.navigate([this.currentUrl], navigationExtras);
  }
  splitEvent() {
    const today = new Date(); // Get today's date
    today.setHours(0, 0, 0, 0); // Set to midnight to compare only the date part

    const startDate = new Date(this.event.startDate); // Convert event start date to Date object
    startDate.setHours(0, 0, 0, 0); // Set to midnight to compare only the date part

    if (startDate < today) {
      // If event start date is before today, set isPastEvent to true and isRegisterable to false
      this.isPastEvent = true;

    } else {
      // If event start date is today or after, set isPastEvent to false and isRegisterable to true
      this.isPastEvent = false;

    }
  }
  // getBannerImage(): string {
  //   return this.event.images.length ? this.getImagePath(this.event.images[0].path) : 'path/to/default/banner.jpg';
  // }

  getImagePath(relativePath: string): string {
    return Constants.baseUrl + `/` + `${relativePath}`;
  }
  getImageUrl(bannerImage: string) {
    if (bannerImage != null) {

      return Constants.baseImageUrl + bannerImage;
    } else {
      return '../../../assets/images/InternshipPage/business-conference-banner-template-design-for-webinar-marketing-online-class-program-etc-free-vector.jpg'
    }
  }
  onFileChanged(event: any) {
    this.selectedFile = event.target.files[0];
  }
  submitted = false;
  onSubmit(): void {
    this.submitted = true;
     this.payNow();
    // Check if the form is valid
    if (this.form.invalid) {
      this.loading = true;
      return;
    }
    // Disable the submit button while processing
    this.isSubmitting = true;
    const uploadData = new FormData();
    console.log(this.form.value);
    uploadData.append('Name', this.form.get('Name')!.value);
    uploadData.append('College', this.form.get('College')!.value);
    uploadData.append('Qualification', this.form.get('Qualification')!.value);
    uploadData.append('Email', this.form.get('Email')!.value);
    uploadData.append('Phone', this.form.get('Phone')!.value);
    uploadData.append('Designation', this.form.get('Designation')?.value);
    // this.payNow();
 

    this.http.post(Constants.baseUrl + '/api/Enrollment/eventRegistrationData/' + this.eventId, uploadData)

      .subscribe(
        (response: any) => {

          this.form.reset();
          this.isSubmitting = false;
          this.dialogRef = this.dialog.open(ThankYouPopupComponent, {
            data: {
              title: 'Thanks For Registering',
              message: ''
            }
          });

          setTimeout(() => {
            this.dialogRef.close();
            this.dialog.closeAll();
            this.loading = false; // Hide loader
          }, 4000);
          this.router.navigate(['mitevents']);
        },
        (error) => {
          this.isSubmitting = false;
          this.loading = false;
        }
      );
  }
  // Utility function to handle form validation
  isFormControlInvalid(controlName: string): boolean {
    const control = this.form.get(controlName);
    if (control) {
      return control.invalid && (control.dirty || control.touched || this.submitted);
    }
    return false;
  }
sendformdata( uploadData:any){

  this.http.post(Constants.baseUrl + '/api/Enrollment/eventRegistrationData/' + this.eventId, uploadData)

      .subscribe(
        (response: any) => {

          this.form.reset();
          this.isSubmitting = false;
          this.dialogRef = this.dialog.open(ThankYouPopupComponent, {
            data: {
              title: 'Thanks For Registering',
              message: 'You can visit our site for latest updates '
            }
          });
         

          setTimeout(() => {
            this.dialogRef.close();
          }, 4000);
          this.router.navigate(['mitevents']);
        },
        (error) => {
          this.isSubmitting = false;
        }
      );
}
  // Function to get the error message for a specific control
  getErrorMessage(controlName: string): string {
    const control = this.form.get(controlName);
    if (control?.hasError('required')) {
      return `${controlName.replace('input', '')} is required.`;
    } else if (control?.hasError('emptyName')) {
      return 'Name cannot be empty.';
    } else if (control?.hasError('invalidName')) {
      return 'Name can accept spaces, alphabets, and hyphens only.';
    }   else if (control?.hasError('invalidCollegeName')) {
      return 'College / Organization is Required';
    } 
    else if (control?.hasError('emptyEmail')) {
      return 'Email is required.';
    } else if (control?.hasError('invalidEmail')) {
      return 'Enter a valid business email.';
    } else if (control?.hasError('emptyPhone')) {
      return 'Phone number is required.';
    // } else if (control?.hasError('invalidPhone')) {
    //   return 'Enter a valid phone number.';
    } else if (control?.hasError('maxlength')) {
      return 'maximum 50 characters'
    }
    else if (control?.hasError('minlength')) {
      return 'Full Name must be at least 2 characters long without spaces';
    }
    else if (control?.hasError('invalidCollegeName')) {
      return 'College / Organizationmust be at least 3 characters long without spaces';
    }
    else if (control?.hasError('pattern')){
      return 'Enter valid Name'
    }
     else {
      return '';
    }
  }
 

  // Custom validator for the name input
  customNameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { emptyName: true }; // Name is empty
      }
      if (!/^[a-zA-Z ]*$/.test(control.value)) {
        return { invalidName: true }; // Invalid characters in name
      }
      return null;
    };
  }
  customCollegeNameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { emptyName: true }; // Name is empty
      }
      if (!/^[a-zA-Z ]*$/.test(control.value)) {
        return { invalidCollegeName: true }; // Invalid characters in name
      }
      return null;
    };
  }

  // Custom validator for email input
  customEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { emptyEmail: true }; // Email is empty
      }
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(control.value)) {
        return { invalidEmail: true }; // Invalid email format
      }
      return null;
    };
  }
  onFileChange(event: any) {
    if (event.target.files[0].length > 0) {
      const file = event.target.files[0];
      this.form.patchValue({
        attachment: file
      });
    }
  }

  // Custom validator for phone number input
  customPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { emptyPhone: true }; // Phone number is empty
      }
      if (!/^\+?\d{10,12}$/.test(control.value)) {
        return { invalidPhone: true }; // Invalid phone number
      }
      return null;
    };
  }
  @ViewChild('empSwiperContainer', { static: false }) empSwiperContainer!: ElementRef;
  @ViewChild('overlay', { static: false }) overlay!: ElementRef<HTMLDivElement>;
  @ViewChild('image', { static: false }) image!: ElementRef<HTMLImageElement>;

  showOverlay = false;
  imageSrc = '';
  openLightbox(imageSrc: string): void {
    this.imageSrc = this.getImageUrl(imageSrc);
    this.showOverlay = true;
  }

  closeLightbox(): void {
    this.showOverlay = false;
  }

  showNextImage(): void {
    const currentIndex = this.galleryImages.findIndex(img => img.imageUrl === this.imageSrc);
    const nextIndex = (currentIndex + 1) % this.galleryImages.length;
    this.imageSrc = this.getImageUrl(this.galleryImages[nextIndex].imageUrl);
  }

  showPrevImage(): void {
    const currentIndex = this.galleryImages.findIndex(img => img.imageUrl === this.imageSrc);
    const prevIndex = (currentIndex - 1 + this.galleryImages.length) % this.galleryImages.length;
    this.imageSrc = this.getImageUrl(this.galleryImages[prevIndex].imageUrl);
  }



  loadTestimonials(meetUpId: number): void {
    this.eventService.getTestimonialsByMeetUpId(meetUpId).subscribe(
      (data: any) => {
        
        this.testimonials = data;
        this.isTestimonialsExists = this.testimonials.length > 0; 
                // this.testimonials = this.chunkArray(data, 3);

      },
      (error: any) => {
        // console.error('Error fetching testimonials', error);
      }
    );
  }


  // Utility function to chunk the testimonials into groups of n items
  chunkArray(testimonialsArray: any[], chunkSize: number): any[][] {
    const chunks = [];
    for (let i = 0; i < testimonialsArray.length; i += chunkSize) {
      chunks.push(testimonialsArray.slice(i, i + chunkSize));
    }
    return chunks;
  }

  payNow() {
    const RozarpayOptions = {
      description: 'Sample Razorpay demo',
      currency: 'INR',
      amount: 100000,
      name: 'Ashok',
      key: 'rzp_test_JI0uGG64CbnsV1', 
      image: 'https://i.imgur.com/FApqk3D.jpeg',
      prefill: {
        name: this.form.value.Name,
        email: this.form.value.Email,
        contact: this.form.value.Phone,
      },
      theme: {
        color: '#6466e3'
      },
      modal: {
        ondismiss:  () => {
          // console.log('dismissed')
        }
      }
    }
    const successCallback = (paymentId: any) => {
      // console.log(paymentId);
      this.fetchPaymentDetails(paymentId);
    }
 
    const failureCallback = (e: any) => {
      // console.log(e);
    }
 
    Razorpay.open(RozarpayOptions,successCallback, failureCallback)
  } 
  fetchPaymentDetails(paymentId: string) {
    this.paymentService.getPaymentDetails(paymentId).subscribe(
      (paymentDetails) => {
        // console.log(paymentDetails);
        this.savePaymentDetails(paymentDetails);
      },
      (error) => {
        // console.error('Error fetching payment details', error);
      }
    );
  }
  savePaymentDetails(paymentDetails: any) {
    this.paymentService.savePaymentDetails(paymentDetails).subscribe(
      (response) => {
        // console.log('Payment details saved successfully', response);
      },
      (error) => {
        // console.error('Error saving payment details', error);
      }
    );
  }

  loadRazorpayScript() {
    if(this.isBrowser){
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => {
      // console.log('Razorpay script loaded successfully.');
    };
    document.body.appendChild(script);
  }
  }

  payWithRazorpay(orderId: string) {
    const options: any = {
      key: 'rzp_test_JI0uGG64CbnsV1', // Replace with your Razorpay Key ID
      amount: 50000, // Amount in paise (50000 paise = 500 INR)
      currency: 'INR',
      name: 'Event Registration',
      description: 'Register for the event',
      order_id: orderId,
      handler: (response: any) => {
        this.verifyPayment(response);
      },
      prefill: {
        name: this.form.value.Name,
        email: this.form.value.Email,
        contact: this.form.value.Phone,
      },
      theme: {
        color: '#3399cc'
      }
    };

    const razorpayInstance = new Razorpay(options);
    razorpayInstance.open();
  }

  // Payment verification after success
  verifyPayment(paymentResponse: any) {
    this.http.post('/api/payment/verify-payment', paymentResponse).subscribe((res: any) => {
      alert('Payment successful!');
      this.isSubmitting = false;
      
    }, err => {
      // console.error(err);
      alert('Payment verification failed!');
      this.isSubmitting = false;
    });
  }
  
  onPhoneInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length > 13) {
      input.value = input.value.slice(0, 13); // Trim to 13 characters
      this.form.get('contactPhone')?.setValue(input.value);
    }
  }
}
